export type ArcCoverageMode = 'exact' | 'distance' | 'off';

export const DEFAULT_ARC_COVERAGE_MODE: ArcCoverageMode = 'exact';

export function resolveArcCoverageMode(value: unknown): ArcCoverageMode {
  return value === 'distance' || value === 'off' || value === 'exact'
    ? value
    : DEFAULT_ARC_COVERAGE_MODE;
}
